import { TOPIC_COUNSELLOR } from 'mk/autogenerated/translations/CounsellingUserChip.3dcf4e3f0693289aa73b61c6de258c94'
import { counsellingsTopicUrl } from 'mk2/apps/counsellings/urls';
import { CounsellingCounsellorEntity } from 'mk2/apps/forum/schemas';
import { ImgCropped, ImgCropMode } from 'mk2/components/ImgCropped';
import { Link } from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './CounsellingUserChip.mscss';

interface OwnProps {
    counsellor: CounsellingCounsellorEntity;
}

export class CounsellingUserChip extends React.Component<OwnProps> {
    public render() {
        const {
            counsellor,
        } = this.props;

        const counsellingUrl = url(counsellingsTopicUrl, { topicSlug: counsellor.counselling.topic.slug });

        return (
            <Link
                className={styles.CounsellingUserChip}
                to={counsellingUrl}
            >
                <ImgCropped
                    width={32}
                    height={32}
                    photo={counsellor.avatarPhoto}
                    photoVersion="s150x150"
                    className={styles.CounsellingUserChip__avatar}
                    mode={ImgCropMode.Cover}
                />

                <div className={styles.CounsellingUserChip__info}>
                    <div className={styles.CounsellingUserChip__name}>
                        {counsellor.name}
                    </div>
                    <div className={styles.CounsellingUserChip__badge}>
                        {TOPIC_COUNSELLOR}
                    </div>
                </div>
            </Link>
        );
    }
}
